export const ALLOWED_EXTENSIONS = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.tif', '.tiff'] as const
export const MAX_FILE_SIZE_BYTES = 20 * 1024 * 1024

export type UploadStatus = 'uploading' | 'done' | 'error'

export interface UploadEntry {
  id: string
  name: string
  status: UploadStatus
  progress: number
  asset?: UploadedAsset
}

export interface UseFileUploadOptions {
  maxFiles?: number
  initialAssets?: UploadedAsset[]
}

export interface UseFileUploadReturn {
  entries: UploadEntry[]
  isUploading: boolean
  uploadedAssets: UploadedAsset[]
  addFiles: (files: File[]) => void
  removeEntry: (id: string) => void
}

export interface UploadedAsset {
  publicUrl: string
  fileName: string
  name: string
  id: string
}
